/**
 * @deprecated since v5.
 */
export class TerraCheckboxTreeLeafState {
    public allChildrenAreChecked: boolean = true;
    public noChildrenAreChecked: boolean = true;
    public isIndeterminate: boolean = false;
}
